import { ProductColor, Product } from 'idt-ecommerce-api/catalog/products/products.models';

import { MediasHelpers } from './medias/medias.helpers';
import { MediaClazzType, MediaLocation, MediaResolved, MediaContentTypeType } from './medias/medias.models';


export class ProductsHelpers {

  public static firstImageForFirstColor(
    colors: ProductColor[],
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType | string,
    set?: number
  ): MediaResolved | undefined {
    let firstImage: MediaResolved | undefined;

    if (colors.length > 0) {
      firstImage = MediasHelpers.firstMediaResolved(colors[0].medias, location, width, clazzType, 'image', set);
    }

    return firstImage;
  }

  public static firstImageForColor(
    color: ProductColor,
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType | string,
    set?: number
  ): MediaResolved | undefined {
    return MediasHelpers.firstMediaResolved(color.medias, location, width, clazzType, 'image', set);
  }

  public static imagesForColor(
    color: ProductColor,
    location: MediaLocation,
    width?: number,
    mediaContentType?: MediaContentTypeType,
    clazzType?: MediaClazzType
  ): MediaResolved[] {
    const images = MediasHelpers.mediasResolved(color.medias, location, width, clazzType, mediaContentType);
    return images;
  }

  public static allImagesForProduct(
    product: Product,
    location: MediaLocation,
    width?: number,
    clazzType?: MediaClazzType
  ): MediaResolved[] {
    let imagesForProduct: MediaResolved[] = [];
    for (const color of product.colors || []) {
      const mediasForColor = MediasHelpers.mediasResolved(color.medias, location, width, clazzType, 'image');
      imagesForProduct = imagesForProduct.concat(mediasForColor);
    }
    return imagesForProduct;
  }

}
